import { createContext, PropsWithChildren, useContext, useRef } from 'react'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'
import { StickyFooterContext, StickyFooterProviderProps } from 'providers/StickyFooterProvider/Types'
import { StickyFooter } from 'providers/StickyFooterProvider/StickyFooter'

const Context = createContext<StickyFooterContext>({
  isFloating: false,
})

export const StickyFooterProvider = ({ children, footer }: PropsWithChildren<StickyFooterProviderProps>) => {
  const contentRef = useRef(null)
  const entry = useIntersectionObserver(contentRef, {})

  return (
    <Context.Provider value={{ isFloating: (entry && !entry?.isIntersecting) || false }}>
      {children}
      <div ref={contentRef} />
      <StickyFooter>{footer}</StickyFooter>
    </Context.Provider>
  )
}

export const useStickyFooter = () => useContext(Context)
